export default __webpack_public_path__ + "static/media/Ravenclaw Bracers.2b9e93b3.jpg";